import type { Item } from 'typings'

export function normalizeString(input: string): string {
  return input
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .toLocaleLowerCase()
}

export function searchItems(items: Item[] = [], term: string) {
  const normalizedTerm = normalizeString(term)

  return items.filter(
    (item) =>
      normalizeString(item.name).includes(normalizedTerm) || item.id === term
  )
}

export function search(values: string[], term: string) {
  const normalizedTerm = normalizeString(term)

  return values.filter((value) =>
    normalizeString(value).includes(normalizedTerm)
  )
}
